// src/components/Success.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {BACKEND_ENDPOINT} from "../const/appConst";
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Knowlege from '../section-pages/knowlege';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';

const image1 ="../../img/background/space.webp";

const GlobalStyles = createGlobalStyle`

`;

const Success = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const sessionId = query.get('session_id');
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (sessionId) {
            fetch(`${BACKEND_ENDPOINT}/stripe/success?session_id=${sessionId}`)
                .then(response => {
                    console.log("received response: ", response)
                    if (!response.ok) {
                        console.error('Response not OK:', response);
                        return response.text().then(text => { throw new Error(text); });
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        setMessage('Payment was successful! Thank you for your purchase.');
                    } else {
                        setMessage('Payment succeeded, but there was an issue updating your account.');
                    }
                    setLoading(false);
                })
                .catch(error => {
                    setMessage('There was an error processing your payment.');
                    setLoading(false);
                });
        } else {
            setMessage('No session ID found.');
            setLoading(false);
        }
    }, [sessionId]);

    if (loading) return <div>Loading...</div>;

    return (
        <>
            {/* HEAD */}
            <Helmet>
                <link rel="icon" href="./img/icon.png" />
                <title>Stripe Payment</title>
            </Helmet>

            <GlobalStyles/>

            {/* MENU */}
            <div className="home dark-scheme">
                <header id="header-wrap">
                    <Navbar />
                </header>

                {/* section */}
                <Parallax className="" bgImage={image1} strength={5}>
                    <div className="de-gradient-edge-top"></div>
                    <div className="de-gradient-edge-bottom"></div>
                    <section className="no-bg">
                        <div className="container z-9">
                            <div className="row">
                                <div className="col-lg-12 mb-3 text-center">
                                    <div className="subtitle wow fadeInUp mb-3">Payment Result</div>
                                    <h2 className="wow fadeInUp mb-3" data-wow-delay=".2s">{message}</h2>
                                </div>

                                <div className="col-lg-12 mb-3 text-center">
                                    <button onClick={() => navigate('/aistoryteller')} className="btn btn-primary">
                                        Generate Novels
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </Parallax>

                {/* footer */}
                <Footer/>


            </div>
            <ScrollToTopBtn />
        </>
    );
};

export default Success;
